import { render } from "./SetupFee.vue?vue&type=template&id=1a390571"
import script from "./SetupFee.vue?vue&type=script&lang=js"
export * from "./SetupFee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__